import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'userRole',
  standalone: true,
})

export class UserRolePipe implements PipeTransform {
  transform(roles: any[], role: any): boolean {
      if(roles){
        return roles.some(e => e === role);
      }
      return false;
  }
}
